/**
 * Luzy Theme Overrides
 * Atlas palette (same as test) with Luzy Energía Renovable branding
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/luzy/luzy.png';

export const luzyThemeOverrides: ClientThemeOverrides = {
  clientId: 'luzy',
  logo,
  clientName: 'Luzy Energía Renovable',
  hideHeaderClientName: true,
  headerLogo: {
    width: { xs: 99, sm: 127 },
    height: { xs: 28, sm: 36 },
  },
  palette: {
    light: {
      // Uses Atlas colors from semanticColors (same as test/default)
    },
  },
};
